import { useEffect, useState } from 'react';

import { useOnceReveal } from '@common/hooks';
import { useCatalogProductIdParams, useGetPdpIntegratedData, usePdpBaseInfo } from '@domains/pdp-common';

import { useModelSizeUBL } from '../log/useModelSizeUBL';

const DEFAULT_DISPLAY_COUNT = 2;

export const useModelSizeService = () => {
  const { targetRef, isRevealed } = useOnceReveal({ threshold: 0.1 });
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);
  const { fitting_model_list } = useGetPdpIntegratedData({ catalog_product_id: params.catalog_product_id });
  const { impressionModelSize } = useModelSizeUBL();

  // const [isFullView, setIsFullView] = useState(false);
  // const isMoreView = fitting_model_list?.length > DEFAULT_DISPLAY_COUNT;

  useEffect(() => {
    if (isRevealed) {
      impressionModelSize(product.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRevealed]);

  const onClickMore = () => {
    // setIsFullView(true);
  };

  return {
    targetRef,
    isHide: !fitting_model_list?.length,
    displayButton: false, // isMoreView && !isFullView,
    displayCount: null, // isFullView ? null : DEFAULT_DISPLAY_COUNT,
    modelList: fitting_model_list,
    onClickMore,
  };
};
